import { useMemo } from 'react';
import {
  StepName,
  StepStatus,
  type InternshipProcessWithNames,
} from '../../Types/interfaces';

export const useReadyToSignConventions = (
  internshipProcesses: Array<InternshipProcessWithNames>
) => {
  return useMemo(() => {
    return internshipProcesses.filter((process) =>
      process.processSteps.some(
        (step) =>
          step.stepName ===
            'SigningInternshipConventionByUniversitySupervisor' &&
          step.stepStatus === 1 &&
          !step.disabled
      )
    );
  }, [internshipProcesses]);
};

export const useEvaluatedReports = (
  internshipProcesses: Array<InternshipProcessWithNames>
) => {
  return useMemo(() => {
    return internshipProcesses.filter(
      (process) =>
        process.processSteps.some(
          (step) =>
            step.stepName === StepName.signingEvaluationReportByTutor &&
            step.stepStatus === StepStatus.finished
        ) &&
        process.processSteps.some(
          (step) =>
            step.stepName === StepName.signingInternshipConventionByRector &&
            (step.disabled ||
              step.stepStatus === StepStatus.updated ||
              step.stepStatus === StepStatus.finished)
        ) &&
        process.processSteps.some(
          (step) =>
            step.stepName === 'GradingWorkReportByUniversitySupervisor' &&
            step.stepStatus !== StepStatus.finished
        )
    );
  }, [internshipProcesses]);
};
